import { ScheduleType } from 'mbs-ui-shared@models/backup/schedule-models';
import { PlanTypes } from 'mbs-ui-shared@models/PlanTypes.enum';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { BackupDiskImagePlan } from 'wizards/models/base/ibb-plan-model';
import { IBBFormModel } from 'wizards/models/ibb/ibb-form-model';
import { BaseForPlanHelper } from '../../models/base/base-models/base-for-plan-helper';

export class IBBPlanFromStepsHelper extends BaseForPlanHelper {
  public static IBBModel: IBBFormModel = null;

  public static getUpdatedPlan(
    plan,
    model: IBBFormModel,
    settings: WizardHelpersSettings,
    isNBF = false,
    isUnix = false
  ): BackupDiskImagePlan {
    this.IBBModel = model;
    this.isNBF = isNBF;
    this.isUnix = isUnix;
    this.isNetBuild = settings.isNetBuild;
    this.isNBFWithHybrid = isNBF && this.canHybridOnNbf(settings.agentVersion);
    this.updateSchedules(+ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring, this.IBBModel.scheduleAdvancedStep);
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    PlanDataFromStepsHelper.updateNewPlanByNameStep(newPlan, this.IBBModel.planNameStep);

    if (this.isNBFWithHybrid) {
      PlanDataFromStepsHelper.updateNewPlanNBFHybridByWhereBackupStep(
        newPlan,
        this.IBBModel.whereBackupStep,
        this.isUnix && !this.isNetBuild && this.isNBF
      );
    } else PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.IBBModel.whereBackupStep, this.isNBF);

    PlanDataFromStepsHelper.updateNewPlanByCompressionEncryptionStep(newPlan, this.IBBModel.compressionEncryptionStep, this.isNBF);
    if (!this.isNBF) {
      PlanDataFromStepsHelper.updateNewPlanByRetentionPolicyStep(
        newPlan,
        this.IBBModel.retentionPolicyStep,
        this.IBBModel.whereBackupStep.IsHybridBackup,
        false,
        PlanTypes.BackupDiskImagePlan
      );
      PlanDataFromStepsHelper.updateNewPlanByScheduleStep(
        newPlan,
        this.IBBModel.scheduleStep,
        this.IBBModel.scheduleAdvancedStep,
        this.IBBModel.simpleScheduleStep
      );
    } else {
      PlanDataFromStepsHelper.updateNewNBFPlanByRetentionPolicyStep(newPlan, this.IBBModel.retentionPolicyStep, true);

      if (this.isNBFWithHybrid) {
        PlanDataFromStepsHelper.updateNewNBFPlanWithHybridByRetentionPolicyStep(newPlan, this.IBBModel.retentionPolicyStep);
      }

      PlanDataFromStepsHelper.updateNewPlanArchiveByArchiveConsistencyStep(newPlan, this.IBBModel.archiveConsistencyStep, true);
      PlanDataFromStepsHelper.updateNewNBFPlanByScheduleStep(newPlan, this.IBBModel.scheduleStep);
    }
    PlanDataFromStepsHelper.updateNewPlanByWhatBackupStep(newPlan, this.IBBModel.whatBackupStep);
    PlanDataFromStepsHelper.updateNewPlanByAdvancedOptionsStep(
      newPlan,
      this.IBBModel.advancedOptionsStep,
      this.IBBModel.advancedOptionsFlags,
      settings.planType,
      this.isNBF
    );
    PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(newPlan, this.IBBModel.prePostActionsStep, !settings.allowPrePostActions);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.IBBModel.notificationStep);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan, !settings.isRD);
  }
}
